import React from 'react';
import MentorEditForm, { REQUIRED_CHOICE, REQUIRED_COMMENT, YES_NO_NA_OPTIONS } from '../MentorEditForm';

// Mirrors the field set of CreateObservation. Keep the two in step.
const FIELDS = [
    {
        name: 'respectful_entry',
        label: "Did the employee enter the patient's room respectfully (knocked and asked to come in, used the patient's preferred name, introduced his/her self by name and role, etc.)",
        input: 'select',
        options: YES_NO_NA_OPTIONS,
        rules: REQUIRED_CHOICE
    },
    { name: 'respectful_entry_note', label: 'Comments:', input: 'textarea', rules: REQUIRED_COMMENT },
    {
        name: 'encourage_questions',
        label: 'Did the employee encourage questions from the patient, probing for concerns or fears?',
        input: 'select',
        options: YES_NO_NA_OPTIONS,
        rules: REQUIRED_CHOICE
    },
    { name: 'encourage_questions_note', label: 'Comments:', input: 'textarea', rules: REQUIRED_COMMENT },
    {
        name: 'teachback',
        label: 'Did the employee use teach-back?',
        input: 'select',
        options: YES_NO_NA_OPTIONS,
        rules: REQUIRED_CHOICE
    },
    { name: 'teachback_note', label: 'Comments:', input: 'textarea', rules: REQUIRED_COMMENT },
    {
        name: 'listen',
        label: 'Did the employee listen carefully and explain things in a way the patient could understand?',
        input: 'select',
        options: YES_NO_NA_OPTIONS,
        rules: REQUIRED_CHOICE
    },
    { name: 'listen_note', label: 'Your comments:', input: 'textarea', rules: REQUIRED_COMMENT },
    { name: 'followup_note', label: 'Plan for follow up:', input: 'textarea', rules: REQUIRED_COMMENT },
];

export default function EditObservation({ employee, mentor, onSaved }) {
    return (
        <MentorEditForm
            title='Edit Observation'
            employee={employee}
            mentor={mentor}
            fields={FIELDS}
            onSaved={onSaved}
        />
    )
}
